<div class="col gap-16">
  <div class="row w100 space-between">
    <h1>Promotion Code</h1>
    <rr-icon class="pointer" name="close" (click)="close()"></rr-icon>
  </div>
  <form class="w100 col gap-16" (ngSubmit)="generatePromolink()">
    <rr-input
      label="Name"
      [required]="true"
      placeholder="e.g. Messe München"
      [formControl]="controlName"
    ></rr-input>
    <rr-input
      label="Expire"
      [required]="true"
      type="date"
      [formControl]="controlExpireDate"
    ></rr-input>
    <div class="row gap-16 w100">
      <rr-input
        class="grow-1"
        type="number"
        label="Usages"
        [formControl]="controlCounter"
        hint="How many times the link can be used. 0 or empty for infinite usage."
      ></rr-input>
      <rr-input
        class="grow-1"
        type="number"
        label="Credits"
        [formControl]="controlCredits"
      ></rr-input>
    </div>
    <div class="col gap-4">
      <!-- <h4 class="color-strong small">Skip Registration</h4> -->
      <div class="row">
        <rr-checkbox [formControl]="controlSkipRegistration"></rr-checkbox>
        <div class="col">
          <small class="small"
            >Skip registration: The customers can skip the registration and
            enter directly to the target you choose. Activate the checkbox if
            you want it.</small
          >
        </div>
      </div>
    </div>
    <div class="row justify-end w100">
      <rr-btn type="Primary" size="Medium">Generate</rr-btn>
    </div>
  </form>

  <div class="resultarea col gap-16 w100" *ngIf="promolink != ''">
    <div class="linkarea w100">
      <h4 class="color-strong">Your Link</h4>
      <div class="promolink row gap-8 align-center">
        <div>{{ promolink }}</div>
        <rr-btn type="secondary" (click)="copyToClipboard()"
          >Copy to clipboard</rr-btn
        >
      </div>
      <div class="small row justify-end w100" *ngIf="linkcopied">
        Link copied
      </div>

      <div class="row gap-24 align-center">
        <!-- <qrcode [qrdata]="promolink" id="qrcode"></qrcode> -->
        <div class="col gap-16">
          <h4 class="color-strong">Test the QR-Code</h4>
          <div class="col gap-8">
            <span
              >Test the QR-Code by scanning it with your smartphone. You will be
              redirected to the Track starting-page.</span
            >

            <rr-btn
              class="align-self-end"
              type="Link"
              size="Small"
              iconEnd="download"
              (click)="downloadQrCode()"
              >Download QR-Code</rr-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="closerow row w100 justify-end gap-8">
  <rr-btn type="Secondary" (click)="close()">Close</rr-btn>
  <rr-btn type="Primary" (click)="savePromoLink()" *ngIf="promolink != ''"
    >Save Link</rr-btn
  >
</div>
<rr-spinner *ngIf="hideLoading === false"></rr-spinner>
